import moment from "moment";

export const KYC_TABLE_SEARCH_PARAM = "kycSearch";
export const KYC_MATERIALS_CUSTOMER_PARAM = "kycMaterialsCustomer";
export const KYC_GROUP_COMPANY_PARAM = "kycGroupCompany";
export const KYC_MATERIAL_DETAILS_TAB_PARAM = "materialTab";
export const KYC_PARTNER_DETAILS_TAB_PARAM = "partnerTab";
export const KYC_PARTNER_NAV_STORAGE_PREFIX = "kyc-partner-nav:";
export const KYC_MATERIAL_NAV_STORAGE_PREFIX = "kyc-material-nav:";
export const KYC_DESIGN_NAV_STORAGE_PREFIX = "kyc-design-nav:";
export const KYC_QUOTATION_NAV_STORAGE_PREFIX = "kyc-quotation-nav:";
export const KYC_ORDER_NAV_STORAGE_PREFIX = "kyc-order-nav:";
export const KYC_GLOBAL_FILTER_STORAGE_KEY = "kyc-global-filter-payload";

export const KYC_COMPANY_TAB_LABELS = {
	groupCompany: "Group Company",
	account: "Account",
	materials: "Materials",
	quotation: "Quotation",
	orders: "Orders",
	design: "Design",
};

export const KYC_MATERIAL_DETAILS_TAB_LABELS = {
	characteristics: "Material Characteristics",
	quotation: "Quotation",
	orders: "Orders",
	design: "Design",
	customer: "Customer",
	cardiogram: "Cardiogram",
	quality: "Quality Issue",
};

export const KYC_DEFAULT_MATERIAL_DETAILS_TAB = "characteristics";

export const KYC_PARTNER_DETAIL_TAB_LABELS = {
	partnerFunction: "Partner Function",
	material: "Material",
	quotation: "Quotation",
	orders: "Orders",
	design: "Design",
	creditDetail: "Credit Detail",
	cardiogram: "Cardiogram",
};

export const KYC_DEFAULT_PARTNER_DETAILS_TAB = "partnerFunction";

export const isValidPartnerDetailsTab = (tab) =>
	Boolean(tab && Object.prototype.hasOwnProperty.call(KYC_PARTNER_DETAIL_TAB_LABELS, tab));

export const resolvePartnerDetailsTab = (tab) =>
	isValidPartnerDetailsTab(tab) ? tab : KYC_DEFAULT_PARTNER_DETAILS_TAB;

export const isValidMaterialDetailsTab = (tab) =>
	Boolean(tab && Object.prototype.hasOwnProperty.call(KYC_MATERIAL_DETAILS_TAB_LABELS, tab));

export const resolveMaterialDetailsTab = (tab) =>
	isValidMaterialDetailsTab(tab) ? tab : KYC_DEFAULT_MATERIAL_DETAILS_TAB;

export const buildKycMaterialCharacteristicsUrl = (productName, { materialTab } = {}) => {
	const trimmedProduct = String(productName || "").trim();
	if (!trimmedProduct) {
		return "/kyc";
	}

	const basePath = `/kyc/material-characteristics/${encodeURIComponent(trimmedProduct)}`;
	const resolvedTab = resolveMaterialDetailsTab(materialTab);
	if (!resolvedTab || resolvedTab === KYC_DEFAULT_MATERIAL_DETAILS_TAB) {
		return basePath;
	}

	const params = new URLSearchParams();
	params.set(KYC_MATERIAL_DETAILS_TAB_PARAM, resolvedTab);
	return `${basePath}?${params.toString()}`;
};

export const buildKycMaterialDesignTabReturn = ({
	productName = "",
	materialName = "",
	groupCompanyId = "",
	groupCompanyName = "",
	materialsCustomer = "",
	accountName = "",
	returnTab = "materials",
} = {}) => {
	const trimmedProduct = String(productName || materialName || "").trim();
	return {
		link: buildKycMaterialCharacteristicsUrl(trimmedProduct, { materialTab: "design" }),
		state: {
			materialName: String(materialName || trimmedProduct).trim(),
			groupCompanyId: String(groupCompanyId || "").trim(),
			groupCompanyName: String(groupCompanyName || "").trim(),
			materialsCustomer: String(materialsCustomer || "").trim(),
			accountName: String(accountName || "").trim(),
			returnTab: returnTab || "materials",
		},
	};
};

export const buildKycMaterialQuotationTabReturn = ({
	productName = "",
	materialName = "",
	groupCompanyId = "",
	groupCompanyName = "",
	materialsCustomer = "",
	accountName = "",
	returnTab = "materials",
} = {}) => {
	const trimmedProduct = String(productName || materialName || "").trim();
	return {
		link: buildKycMaterialCharacteristicsUrl(trimmedProduct, { materialTab: "quotation" }),
		state: {
			materialName: String(materialName || trimmedProduct).trim(),
			groupCompanyId: String(groupCompanyId || "").trim(),
			groupCompanyName: String(groupCompanyName || "").trim(),
			materialsCustomer: String(materialsCustomer || "").trim(),
			accountName: String(accountName || "").trim(),
			returnTab: returnTab || "materials",
		},
	};
};

export const buildKycMaterialOrdersTabReturn = ({
	productName = "",
	materialName = "",
	groupCompanyId = "",
	groupCompanyName = "",
	materialsCustomer = "",
	accountName = "",
	returnTab = "materials",
} = {}) => {
	const trimmedProduct = String(productName || materialName || "").trim();
	return {
		link: buildKycMaterialCharacteristicsUrl(trimmedProduct, { materialTab: "orders" }),
		state: {
			materialName: String(materialName || trimmedProduct).trim(),
			groupCompanyId: String(groupCompanyId || "").trim(),
			groupCompanyName: String(groupCompanyName || "").trim(),
			materialsCustomer: String(materialsCustomer || "").trim(),
			accountName: String(accountName || "").trim(),
			returnTab: returnTab || "materials",
		},
	};
};

export const buildKycPartnerFunctionUrl = (crmGuid, { partnerTab } = {}) => {
	const trimmedGuid = String(crmGuid || "").trim();
	if (!trimmedGuid) {
		return "/kyc";
	}

	const basePath = `/kyc/partner-function/${encodeURIComponent(trimmedGuid)}`;
	const resolvedTab = resolvePartnerDetailsTab(partnerTab);
	if (!resolvedTab || resolvedTab === KYC_DEFAULT_PARTNER_DETAILS_TAB) {
		return basePath;
	}

	const params = new URLSearchParams();
	params.set(KYC_PARTNER_DETAILS_TAB_PARAM, resolvedTab);
	return `${basePath}?${params.toString()}`;
};

export const buildKycPartnerFunctionTabReturn = ({
	crmGuid = "",
	partnerTab = KYC_DEFAULT_PARTNER_DETAILS_TAB,
	groupCompanyId = "",
	groupCompanyName = "",
	accountName = "",
	materialsCustomer = "",
	returnTab = "account",
} = {}) => ({
	link: buildKycPartnerFunctionUrl(crmGuid, { partnerTab }),
	state: {
		groupCompanyId: String(groupCompanyId || "").trim(),
		groupCompanyName: String(groupCompanyName || "").trim(),
		accountName: String(accountName || "").trim(),
		materialsCustomer: String(materialsCustomer || "").trim(),
		returnTab: returnTab || "account",
	},
});

export const buildKycPartnerFunctionQuotationTabReturn = ({
	crmGuid = "",
	groupCompanyId = "",
	groupCompanyName = "",
	accountName = "",
	materialsCustomer = "",
	returnTab = "account",
} = {}) =>
	buildKycPartnerFunctionTabReturn({
		crmGuid,
		partnerTab: "quotation",
		groupCompanyId,
		groupCompanyName,
		accountName,
		materialsCustomer,
		returnTab,
	});

export const buildKycPartnerFunctionOrdersTabReturn = ({
	crmGuid = "",
	groupCompanyId = "",
	groupCompanyName = "",
	accountName = "",
	materialsCustomer = "",
	returnTab = "account",
} = {}) =>
	buildKycPartnerFunctionTabReturn({
		crmGuid,
		partnerTab: "orders",
		groupCompanyId,
		groupCompanyName,
		accountName,
		materialsCustomer,
		returnTab,
	});

export const buildKycCompanyTabUrl = (companyTab) => {
	if (!companyTab || companyTab === "groupCompany") {
		return "/kyc";
	}

	return `/kyc?companyTab=${encodeURIComponent(companyTab)}`;
};

export const buildKycTableSearchUrl = (searchValue, { companyTab } = {}) => {
	const trimmed = searchValue !== undefined && searchValue !== null ? String(searchValue).trim() : "";
	const params = new URLSearchParams();

	if (trimmed) {
		params.set(KYC_TABLE_SEARCH_PARAM, trimmed);
	}

	if (companyTab && companyTab !== "groupCompany") {
		params.set("companyTab", companyTab);
	}

	const query = params.toString();
	return query ? `/kyc?${query}` : "/kyc";
};

export const saveKycPartnerNavContext = (crmGuid, context = {}) => {
	if (!crmGuid) {
		return;
	}

	try {
		sessionStorage.setItem(`${KYC_PARTNER_NAV_STORAGE_PREFIX}${crmGuid}`, JSON.stringify(context));
	} catch {
		// ignore quota / private mode errors
	}
};

export const loadKycPartnerNavContext = (crmGuid) => {
	if (!crmGuid) {
		return {};
	}

	try {
		const raw = sessionStorage.getItem(`${KYC_PARTNER_NAV_STORAGE_PREFIX}${crmGuid}`);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

export const getKycMaterialNavStorageKey = (productName) =>
	`${KYC_MATERIAL_NAV_STORAGE_PREFIX}${encodeURIComponent(String(productName || "").trim())}`;

export const saveKycMaterialNavContext = (productName, context = {}) => {
	const key = getKycMaterialNavStorageKey(productName);
	if (!key || key === KYC_MATERIAL_NAV_STORAGE_PREFIX) {
		return;
	}

	try {
		sessionStorage.setItem(key, JSON.stringify(context));
	} catch {
		// ignore quota / private mode errors
	}
};

export const loadKycMaterialNavContext = (productName) => {
	const key = getKycMaterialNavStorageKey(productName);
	if (!key) {
		return {};
	}

	try {
		const raw = sessionStorage.getItem(key);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

export const getKycDesignNavStorageKey = (generalDetailId) =>
	`${KYC_DESIGN_NAV_STORAGE_PREFIX}${encodeURIComponent(String(generalDetailId || "").trim())}`;

export const saveKycDesignNavContext = (generalDetailId, context = {}) => {
	const key = getKycDesignNavStorageKey(generalDetailId);
	if (!key || key === KYC_DESIGN_NAV_STORAGE_PREFIX) {
		return;
	}

	try {
		sessionStorage.setItem(key, JSON.stringify(context));
	} catch {
		// ignore quota / private mode errors
	}
};

export const loadKycDesignNavContext = (generalDetailId) => {
	const key = getKycDesignNavStorageKey(generalDetailId);
	if (!key) {
		return {};
	}

	try {
		const raw = sessionStorage.getItem(key);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

export const getKycQuotationNavStorageKey = (quotationId) =>
	`${KYC_QUOTATION_NAV_STORAGE_PREFIX}${encodeURIComponent(String(quotationId || "").trim())}`;

export const saveKycQuotationNavContext = (quotationId, context = {}) => {
	const key = getKycQuotationNavStorageKey(quotationId);
	if (!key || key === KYC_QUOTATION_NAV_STORAGE_PREFIX) {
		return;
	}

	try {
		sessionStorage.setItem(key, JSON.stringify(context));
	} catch {
		// ignore quota / private mode errors
	}
};

export const loadKycQuotationNavContext = (quotationId) => {
	const key = getKycQuotationNavStorageKey(quotationId);
	if (!key) {
		return {};
	}

	try {
		const raw = sessionStorage.getItem(key);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

export const getKycOrderNavStorageKey = (orderId) =>
	`${KYC_ORDER_NAV_STORAGE_PREFIX}${encodeURIComponent(String(orderId || "").trim())}`;

export const saveKycOrderNavContext = (orderId, context = {}) => {
	const key = getKycOrderNavStorageKey(orderId);
	if (!key || key === KYC_ORDER_NAV_STORAGE_PREFIX) {
		return;
	}

	try {
		sessionStorage.setItem(key, JSON.stringify(context));
	} catch {
		// ignore quota / private mode errors
	}
};

export const loadKycOrderNavContext = (orderId) => {
	const key = getKycOrderNavStorageKey(orderId);
	if (!key) {
		return {};
	}

	try {
		const raw = sessionStorage.getItem(key);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

/**
 * Return to Materials tab with the material name in the table search box.
 */
export const buildKycMaterialsTableSearchReturn = ({
	materialName = "",
	groupCompanyId = "",
	groupCompanyName = "",
	materialsCustomer = "",
	accountName = "",
} = {}) => {
	const trimmedMaterial = String(materialName || "").trim();
	const materials = String(materialsCustomer || "").trim();
	const account = String(accountName || "").trim();
	const groupName = String(groupCompanyName || "").trim();
	const groupId = String(groupCompanyId || "").trim();

	const link = trimmedMaterial
		? buildKycTableSearchUrl(trimmedMaterial, { companyTab: "materials" })
		: buildKycCompanyTabUrl("materials");

	return {
		link,
		state: {
			returnTab: "materials",
			...(trimmedMaterial ? { tableSearch: trimmedMaterial, materialName: trimmedMaterial } : {}),
			...(materials ? { materialsCustomer: materials } : {}),
			...(account ? { accountName: account } : {}),
			...(groupId ? { groupCompanyId: groupId } : {}),
			...(groupName ? { groupCompanyName: groupName } : {}),
		},
	};
};

/**
 * Builds a dashboard link that restores tab + filters when returning from detail pages.
 */
export const buildKycDashboardReturnLink = ({
	returnTab = "account",
	groupCompanyId = "",
	groupCompanyName = "",
	accountName = "",
	materialsCustomer = "",
} = {}) => {
	const groupId = groupCompanyId ? String(groupCompanyId).trim() : "";
	const groupName = groupCompanyName ? String(groupCompanyName).trim() : "";
	const account = accountName ? String(accountName).trim() : "";
	const materials = materialsCustomer ? String(materialsCustomer).trim() : "";

	if (returnTab === "materials") {
		if (materials || groupName) {
			const params = new URLSearchParams();
			params.set("companyTab", "materials");
			if (materials) {
				params.set(KYC_MATERIALS_CUSTOMER_PARAM, materials);
			}
			if (groupName) {
				params.set(KYC_TABLE_SEARCH_PARAM, groupName);
			}
			const drillAccountName = account || materials;
			return {
				pathname: "/kyc",
				search: `?${params.toString()}`,
				state: {
					returnTab: "materials",
					...(materials ? { materialsCustomer: materials } : {}),
					...(drillAccountName ? { accountName: drillAccountName } : {}),
					...(groupId ? { groupCompanyId: groupId } : {}),
					...(groupName ? { groupCompanyName: groupName } : {}),
				},
			};
		}
		return buildKycCompanyTabUrl("materials");
	}

	if (returnTab === "account") {
		if (account) {
			const params = new URLSearchParams();
			params.set(KYC_TABLE_SEARCH_PARAM, account);
			params.set("companyTab", "account");
			if (groupName) {
				params.set(KYC_GROUP_COMPANY_PARAM, groupName);
			}
			return {
				pathname: "/kyc",
				search: `?${params.toString()}`,
				state: {
					returnTab: "account",
					...(groupId ? { groupCompanyId: groupId } : {}),
					...(groupName ? { groupCompanyName: groupName } : {}),
					accountName: account,
				},
			};
		}
		if (groupId || groupName) {
			return {
				pathname: "/kyc",
				search: "?companyTab=account",
				state: {
					returnTab: "account",
					groupCompanyId: groupId,
					groupCompanyName: groupName,
				},
			};
		}
		return buildKycCompanyTabUrl("account");
	}

	if (returnTab === "groupCompany") {
		if (groupName) {
			return buildKycTableSearchUrl(groupName);
		}
		if (groupId) {
			return {
				pathname: "/kyc",
				search: "",
				state: {
					returnTab: "groupCompany",
					groupCompanyId: groupId,
					groupCompanyName: groupName,
				},
			};
		}
		return buildKycCompanyTabUrl("groupCompany");
	}

	return buildKycCompanyTabUrl(returnTab);
};

export const getGroupCompanyId = (record = {}) =>
	record?.groupcomanyId ||
	record?.groupCompanyId ||
	record?.groupCompanyMasterId ||
	record?.ispl_GroupCompanyId ||
	record?.id ||
	"";

/** Group / customer-group field used for API scope and parent navigation. */
export const getGroupCompanyName = (record = {}) => {
	const name = record?.groupCompany || record?.ispl_CustomerGroup;
	return name !== undefined && name !== null && String(name).trim() !== "" ? String(name).trim() : "";
};

export const kycBreadcrumbLabelsMatch = (labelA, labelB) => {
	const a = labelA !== undefined && labelA !== null ? String(labelA).trim().toLowerCase() : "";
	const b = labelB !== undefined && labelB !== null ? String(labelB).trim().toLowerCase() : "";
	return Boolean(a && b && a === b);
};

/** Label for a Group Company table row (dashboard breadcrumb; prefers accountName). */
export const getGroupCompanyRowLabel = (record = {}) => {
	const name =
		record?.accountName ||
		record?.groupCompany ||
		record?.ispl_AccountName ||
		record?.ispl_accountName ||
		record?.ispl_CustomerGroup;
	return name !== undefined && name !== null && String(name).trim() !== "" ? String(name).trim() : "";
};

export const hasGroupCompanyScope = ({ groupCompanyId, groupCompanyName } = {}) =>
	Boolean(
		(groupCompanyId && String(groupCompanyId).trim()) ||
			(groupCompanyName && String(groupCompanyName).trim())
	);

export const recordMatchesGroupCompanyScope = (record, { groupCompanyId, groupCompanyName } = {}) => {
	if (!hasGroupCompanyScope({ groupCompanyId, groupCompanyName })) {
		return true;
	}

	if (groupCompanyId) {
		const recordId = getGroupCompanyId(record);
		if (recordId && String(recordId) === String(groupCompanyId)) {
			return true;
		}
	}

	if (groupCompanyName) {
		const normalizedName = String(groupCompanyName).trim().toLowerCase();
		const names = [
			getGroupCompanyName(record),
			getGroupCompanyRowLabel(record),
			record?.accountName,
			record?.groupCompany,
			record?.ispl_AccountName,
			record?.ispl_accountName,
			record?.ispl_CustomerGroup,
		]
			.filter((value) => value !== undefined && value !== null && String(value).trim() !== "")
			.map((value) => String(value).trim().toLowerCase());

		if (names.some((name) => name === normalizedName)) {
			return true;
		}
	}

	return false;
};

/** Contact tile counts from GetKycTileCounts (`contact` or legacy `contacts`). */
export const getContactTileCounts = (apiData = {}) =>
	apiData?.contact || apiData?.contacts || {};

/** Material tile counts from GetKycTileCounts (`material` or legacy `materials`). */
export const getMaterialTileCounts = (apiData = {}) =>
	apiData?.material || apiData?.materials || {};

/** Design tile counts from GetKycTileCounts (`design` or legacy `designs`). */
export const getDesignTileCounts = (apiData = {}) =>
	apiData?.design || apiData?.designs || {};

/** Cylinder tile counts from GetKycTileCounts (`cylinder` or legacy `cylinders`). */
export const getCylinderTileCounts = (apiData = {}) =>
	apiData?.cylinder || apiData?.cylinders || {};

/**
 * Tile counts scope: groupcomanyId from row navigation; customerGroup only from basePayload (global filters).
 */
export const buildKycTileCountsPayloadWithScope = (
	basePayload,
	{ groupCompanyId, isplCustomer } = {}
) => {
	const payload = { ...basePayload };
	if (groupCompanyId && String(groupCompanyId).trim()) {
		payload.groupcomanyId = String(groupCompanyId).trim();
	}
	if (isplCustomer && String(isplCustomer).trim()) {
		payload.ispl_customer = String(isplCustomer).trim();
	}
	return payload;
};

/** API created-on strings use mixed M/D and zero-padded MM/DD plus dot/colon times. */
export const KYC_CREATED_ON_FORMATS = [
	"MM/DD/YYYY h.mm.ss A",
	"M/DD/YYYY h.mm.ss A",
	"MM/D/YYYY h.mm.ss A",
	"M/D/YYYY h.mm.ss A",
	"MM/DD/YYYY h:mm:ss A",
	"M/DD/YYYY h:mm:ss A",
	"MM/D/YYYY h:mm:ss A",
	"M/D/YYYY h:mm:ss A",
	"MM/DD/YYYY HH:mm:ss",
	"MM/DD/YYYY H:mm:ss",
	"M/D/YYYY HH:mm:ss",
	"M/D/YYYY H:mm:ss",
	"YYYY-MM-DD HH:mm:ss",
	moment.ISO_8601,
];

export const formatKycCreatedOnDate = (value) => {
	if (!value || value === "-") {
		return "-";
	}

	const parsedDate = moment(value, KYC_CREATED_ON_FORMATS, true);
	return parsedDate.isValid() ? parsedDate.format("DD/MM/YYYY") : "-";
};

export const getKycLoginSapCode = (loginDetails) =>
	String(
		loginDetails?.sapCode ??
			loginDetails?.employee_Sapcode ??
			loginDetails?.employeeSapCode ??
			loginDetails?.hrmS_Code ??
			loginDetails?.id ??
			""
	).trim();

export const getKycDesignationEmployeeFilters = (loginDetails) => {
	const sapCode = getKycLoginSapCode(loginDetails);
	if (!sapCode) {
		return {};
	}

	const designation = String(loginDetails?.designation || "").trim().toLowerCase();
	if (designation === "director") {
		return { director: sapCode };
	}
	if (designation === "general manager") {
		return { generalManager: sapCode };
	}
	if (designation === "continantal head" || designation === "continental head") {
		return { continentalManager: sapCode };
	}
	if (designation === "regional manager") {
		return { regionalManager: sapCode };
	}
	if (designation === "area manager") {
		return { areaManager: sapCode };
	}
	return {};
};

export const applyKycDesignationEmployeeFilters = (payload = {}, loginDetails) => {
	const overrides = getKycDesignationEmployeeFilters(loginDetails);
	const next = { ...payload };
	Object.entries(overrides).forEach(([field, value]) => {
		const isLoggedInDirector =
			field === "director" &&
			String(loginDetails?.designation || "").trim().toLowerCase() === "director";
		if (isLoggedInDirector || !String(next[field] || "").trim()) {
			next[field] = value;
		}
	});
	return next;
};

export const saveKycGlobalFilterPayload = (payload) => {
	try {
		sessionStorage.setItem(KYC_GLOBAL_FILTER_STORAGE_KEY, JSON.stringify(payload || {}));
	} catch {
		// ignore quota / private mode errors
	}
};

export const loadKycGlobalFilterPayload = () => {
	try {
		const raw = sessionStorage.getItem(KYC_GLOBAL_FILTER_STORAGE_KEY);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
};

export const getKycCompanyCode = (companyDetails) => {
	const fromDetails = companyDetails?.company_Code;
	if (fromDetails !== undefined && fromDetails !== null && String(fromDetails).trim() !== "") {
		return String(fromDetails).trim();
	}
	try {
		return String(localStorage.getItem("Company_Code") || "").trim();
	} catch {
		return "";
	}
};

export const withKycCompanyCode = (payload = {}, companyDetails) => ({
	...payload,
	company_Code: getKycCompanyCode(companyDetails),
});

export const getKycAppliedFilterPayload = (loginDetails, extra = {}) =>
	applyKycDesignationEmployeeFilters(
		withKycCompanyCode({
			...loadKycGlobalFilterPayload(),
			...extra,
		}),
		loginDetails
	);
